import styled from 'styled-components';

export const TickContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: start;
    gap: 1px;
    width: inherit;
    width: fit-content;

    &span {
        line-height: 1.43;
        font-style: SemiBold;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 1.45%;
    }
    @media (max-width: 425px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: start;
    }
`;
